import { getBaseUrl, request } from 'src/helper/api';

export const getQuotes = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/quotes`,
      contentType: 'json',
      token,
      signal,
    },
    'quotes/getQuotes',
  );

export const getQuotesForGroup = (
  token?: string,
  groupKey?: string,
  signal?: AbortSignal,
  attemptId?: number,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/quotes`,
      contentType: 'json',
      token,
      signal,
    },
    'quotes/getQuotesForGroup',
    { _group_key: groupKey, _attempt: attemptId },
  );

export const getQuotesByFilter = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/quotes/filter`,
      contentType: 'json',
      token,
      signal,
    },
    'quotes/getQuotesByFilter',
  );
